import axios from "axios";
import store from "@/store";
import * as C from "@/common";
import { Api } from "./api";
import * as A from "@/core/account";

export enum ShirtSize {
	S = "S",
	M = "M",
	L = "L",
	XL = "XL",
	XXL = "XXL",
}
export enum RegStatus {
	New = "0",
	BillSent = "1",
	Paid = "2",
}
declare type ApiBoolean = "1" | "0";
export interface IRegistration {
	HasDog: ApiBoolean;
	HasFursuit: ApiBoolean;
	Arrival: number;
	Duration: number;
	Room_ID: number;
	RegistrationDate: string;
	Intolerances: string;
	ShirtAmount: ApiBoolean;
	ShirtSize: ShirtSize;
	Sponsor: ApiBoolean;
	Status: RegStatus;
	RegMailSent: string;
	TotalCost: number;
	AcceptRules: ApiBoolean;
	AcceptGdpa: ApiBoolean;
	TotalDogCount: number;
	IsUserComplete: ApiBoolean;
}
export class RegistrationApi extends Api {

	private readonly urlRegPart = "registration/";
	public constructor() {
		super();
	}

	protected get BaseUrl() {
		return super.BaseUrl + this.urlRegPart;
	}

	public async load(id?: number): Promise<IRegistration> {
		const user = await axios.get<IRegistration>(this.buildRegistrationUrl(id), this.Config);

		return user.data;
	}
	public async loadAll(): Promise<IRegistration> {
		const user = await this.executeWithErrorHandling(() => axios.get<IRegistration>(`${this.BaseUrl}all/`, this.Config));
		return user.data;
	}
	public async update(reg: Partial<IRegistration>, id?: number): Promise<boolean> {
		const result = await this.executeWithErrorHandling(() =>  axios.put(this.buildRegistrationUrl(id), reg, this.Config));
		return result.status === 200;
	}

	private buildRegistrationUrl(id?: number) {
		return this.BaseUrl + (id === undefined ? "" : `${id}/`);
	}
}
